import { Component, Inject } from '@angular/core'
import { CommonModule } from '@angular/common'
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatButton } from '@angular/material/button'
import { MatIcon } from '@angular/material/icon'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import {
  ParadaItinerario,
  paradaCidadeEstadoToken,
} from '../../../core/models/parada-itinerario.model'

export interface DialogForkTarifarioData {
  tarifarioCodigo?: string | number
  tarifarioDescricao?: string
  paradasAntes: ParadaItinerario[]
  paradasDepois: ParadaItinerario[]
  mode?: 'standalone' | 'proposta'
}

type DiffRow = {
  ordem: number
  antes: ParadaItinerario | null
  depois: ParadaItinerario | null
  status: 'igual' | 'alterada' | 'adicionada' | 'removida'
}

@Component({
  selector: 'dialog-fork-tarifario',
  standalone: true,
  imports: [
    CommonModule,
    MatButton,
    MatIcon,
    MatCard,
    MatCardHeader,
    MatCardTitle,
  ],
  templateUrl: './dialog-fork-tarifario.component.html',
  styleUrl: './dialog-fork-tarifario.component.scss',
})
export class DialogForkTarifarioComponent {
  diff: DiffRow[] = []
  tarifarioCodigo: string
  mode: 'standalone' | 'proposta'

  constructor(
    private dialogRef: MatDialogRef<DialogForkTarifarioComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: DialogForkTarifarioData,
  ) {
    this.tarifarioCodigo =
      data.tarifarioDescricao ??
      (data.tarifarioCodigo
        ? String(data.tarifarioCodigo)
        : 'original')
    this.mode = data.mode ?? 'standalone'
    this.diff = this.buildDiff(data.paradasAntes ?? [], data.paradasDepois ?? [])
  }

  private buildDiff(
    antes: ParadaItinerario[],
    depois: ParadaItinerario[],
  ): DiffRow[] {
    const maxLen = Math.max(antes.length, depois.length)
    const rows: DiffRow[] = []
    for (let i = 0; i < maxLen; i++) {
      const a = antes[i] ?? null
      const d = depois[i] ?? null
      let status: DiffRow['status'] = 'igual'
      if (a && !d) status = 'removida'
      else if (!a && d) status = 'adicionada'
      else if (a && d && paradaCidadeEstadoToken(a) !== paradaCidadeEstadoToken(d))
        status = 'alterada'
      rows.push({ ordem: i + 1, antes: a, depois: d, status })
    }
    return rows
  }

  paradaLine(p: ParadaItinerario | null): string {
    if (!p) return '—'
    return [p.cidade, p.estado].filter(Boolean).join(' - ') || '—'
  }

  confirm(): void {
    this.dialogRef.close(true)
  }

  cancel(): void {
    this.dialogRef.close(false)
  }
}
